var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pt-5 pb-5 page"},[_c('h1',{staticClass:"mb-5"},[_vm._v("Veelgestelde vragen")]),_c('VueFaqAccordion',{attrs:{"activeColor":"#0080ff","fontColor":"#001e3b","items":_vm.questions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }